import { axios, axiosNoLoading } from "../request/pcAxios"
import store from '../store'
class Center {
  // 获取我的设置
  static getPerSettingsInfo () {
    return axiosNoLoading.post('/nft/public/subscribe/getPerSettingsInfo', {
      enterpriseId: store.state.enterpriseId
    })
  }
  // 修改/新增我的设置信息
  static setPerSettingsInfo (data) {
    return axiosNoLoading.post('/nft/public/subscribe/setPerSettingsInfo', data)
  }
  // 获取草稿列表
  static getArtDraftList () {
    return axios.post('/nft/public/art/draft/getArtDraftList')
  }
  //获取首页列表
  static getWorksHomeInfo (data){         
    return axios.post('/nft/public/subscribe/getWorksHomePageInfo',data)
  }
  // 查询发售列表
  // 类型：1.发售中 2.已售罄 3.已下架
  static getArtSellList (type) {
    return axios.post('/nft/public/art/sell/getArtSellList', { type })
  }
  // 许可列表
  static getArtCastList () {
    return axios.post('/nft/public/art/cast/getArtCastList')
  }
  //我的收藏
  static getCollectionPageInfo (data){         
    return axios.post('/nft/public/subscribe/getCollectionPageInfo',data)
  }
  // 已购作品列表
  static getArtSellInfo (data) {
    return axios.post('/nft/public/seller/record/getArtSellRecordPageInfo',data)
  }
  //粉丝列表
  static getFansPageInfo (data) {
    return axios.post('/nft/public/subscribe/getFansPageInfo',data)
  }
  //粉丝列表
  static getFollowPageInfo (data) {
    return axios.post('/nft/public/subscribe/getFollowPageInfo',data)
  }
  //关注/取消关注
  static setFollowOrCancel (data) {
    return axios.post('/nft/public/subscribe/setFollowOrCancel',data)
  }
  // 创建机构
  static createCompany () {
    return axios.get('/customer/public/enterprise/create')
  }
}

export default Center